import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const BulkSpacePermissionsPage: LoadableType<Omit<unknown, 'flags'>> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkSpacePermissionsPage" */ '../src/BulkSpacePermissionsPage.tsx'
			)
		).BulkSpacePermissionsPage,
	name: 'BulkSpacePermissionsPage',
});
